import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { setStageTab } from '../../../store/user/userSlice';
import { useNavigate } from 'react-router-dom';
import { get_sidebar_menu, setLeftSidebarOpen } from '../../../store/job/jobSlice';
import { SvgIcon } from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import MyLibraryIcon from '../../../assets/my_library.png';
import BrandLibraryIcon from '../../../assets/brand_library.png';

const JobsSvgIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path d="M8 9C8 9.55228 7.55228 10 7 10C7 10 1 10 1 10C0.447715 10 0 9.55228 0 9C0 9 0 1 0 1C0 0.447715 0.447715 0 1 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(3 12)" />
            <path d="M8 9C8 9.55228 7.55228 10 7 10C7 10 1 10 1 10C0.447715 10 0 9.55228 0 9C0 9 0 1 0 1C0 0.447715 0.447715 0 1 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(8 7)" />
            <path d="M8 4C8 3.47004 7.78932 2.96137 7.4143 2.5863C7.4143 2.5863 5.4143 0.586303 5.4143 0.586303C5.03929 0.211019 4.53054 0.000113249 4 0C4 0 1 0 1 0C0.447715 0 0 0.447715 0 1C0 1 0 9 0 9C0 9.55228 0.447715 10 1 10C1 10 7 10 7 10C7.55228 10 8 9.55229 8 9C8 9 8 4 8 4Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(13 2)" />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

const LibrarySvgIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <g>
        <g>
          <path d="M0 2L0 1C0 0.723858 0.097631 0.488155 0.292893 0.292893C0.488155 0.097631 0.723858 0 1 0L7 0C7.27614 0 7.51184 0.097631 7.70711 0.292893C7.90237 0.488155 8 0.723858 8 1L8 17C8 17.2761 7.90237 17.5118 7.70711 17.7071C7.51184 17.9024 7.27614 18 7 18L1 18C0.723858 18 0.488155 17.9024 0.292893 17.7071C0.097631 17.5118 0 17.2761 0 17L0 2Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(3 3)" />
          <path d="M0 0L0 18" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(7 3)" />
          <path d="M9.36265 15.8626C9.56265 16.3626 9.26264 16.9626 8.76264 17.1626C8.76264 17.1626 6.86265 17.8626 6.86265 17.8626C6.36265 18.0626 5.76264 17.7626 5.56265 17.2626C5.56265 17.2626 0.0626459 2.06265 0.0626459 2.06265C-0.137354 1.56265 0.162646 0.962646 0.662646 0.762646C0.662646 0.762646 2.56265 0.0626462 2.56265 0.0626462C3.06265 -0.137354 3.66265 0.162646 3.86265 0.662646C3.86265 0.662646 9.36265 15.8626 9.36265 15.8626Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(11.037 3.037)" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

const ApprovalSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <g>
        <g>
          <path d="M16 11.0005C16 16.0005 12.5 18.5004 8.34 19.9504C8.12216 20.0243 7.88554 20.0207 7.67 19.9404C3.5 18.5004 0 16.0005 0 11.0005C0 11.0005 0 4.00045 0 4.00045C0 3.44816 0.447715 3.00045 1 3.00045C3 3.00045 5.5 1.80045 7.24 0.28045C7.67767 -0.0934832 8.32233 -0.0934833 8.76 0.28045C10.51 1.81045 13 3.00045 15 3.00045C15.5523 3.00045 16 3.44816 16 4.00045C16 4.00045 16 11.0005 16 11.0005Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(4 2)" />
          <path d="M0 2L2 4L6 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(9 10)" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

const SettingsSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <path d="M6.62757 2.11858C6.74174 0.917419 7.7505 0 8.95707 0C10.1636 2.38419e-07 11.1724 0.91742 11.2866 2.11858C11.3538 2.87852 11.7872 3.55798 12.448 3.93925C13.1088 4.32053 13.914 4.35573 14.6056 4.03358C15.7018 3.53587 16.9968 3.95121 17.5991 4.99368C18.2014 6.03615 17.9143 7.36549 16.9356 8.06658C16.3113 8.50463 15.9396 9.21943 15.9396 9.98208C15.9396 10.7447 16.3113 11.4595 16.9356 11.8976C17.9143 12.5987 18.2013 13.928 17.5991 14.9705C16.9968 16.0129 15.7018 16.4283 14.6056 15.9306C13.914 15.6084 13.1088 15.6436 12.448 16.0249C11.7872 16.4062 11.3538 17.0856 11.2866 17.8456C11.1724 19.0467 10.1636 19.9642 8.95707 19.9642C7.75049 19.9642 6.74174 19.0467 6.62757 17.8456C6.56048 17.0854 6.12688 16.4056 5.4658 16.0243C4.80471 15.643 3.99922 15.608 3.30757 15.9306C2.21132 16.4283 0.916318 16.0129 0.314049 14.9705C-0.288221 13.928 -0.00118232 12.5987 0.977567 11.8976C1.60186 11.4595 1.97352 10.7447 1.97352 9.98208C1.97352 9.21943 1.60186 8.50463 0.977567 8.06658C0.00024128 7.36518 -0.286043 6.03702 0.315546 4.99529C0.917135 3.95355 2.21058 3.53767 3.30657 4.03358C3.99812 4.35572 4.8033 4.32052 5.46411 3.93925C6.12491 3.55798 6.55836 2.87852 6.62557 2.11858" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(3.043 2.017)" />
      <path d="M0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(9 9)" />
    </g>
  </SvgIcon>
);

const QuotesSvgIcon = (props) => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(2 2)" />
            <path d="M8 0C8 0 2 0 2 0C0.895431 0 0 0.895431 0 2C0 3.10457 0.895431 4 2 4C2 4 6 4 6 4C7.10457 4 8 4.89543 8 6C8 7.10457 7.10457 8 6 8C6 8 0 8 0 8" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(8 8)" />
            <path d="M0 12L0 0" fill="none" strokeWidth="2" stroke="#54565A" strokeLinecap="round" strokeLinejoin="round" transform="translate(12 6)" />
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);


const StageList = ({ company_process_stage = [], selected_stage_tab, selected_process_tab, ChildComponent }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sidebar_menus, is_left_sidebar_open } = useSelector((state) => state.job);
  const { company_process } = useSelector((state) => state.user);

  const { searchFilters, fromDate, toDate, correctionType } = useSelector((state) => state.job);

  useEffect(() => {
    if (selected_process_tab) {
      dispatch(get_sidebar_menu({
        process_id: selected_process_tab,
        qn: searchFilters?.map(f => f.value.trim()),
        column: searchFilters?.map(f => f.key).filter(Boolean),
        from_date: fromDate,
        to_date: toDate,
        correction_type: correctionType
      }));
    }
  }, [dispatch, selected_process_tab, JSON.stringify(searchFilters), fromDate, toDate, correctionType]);
  const [openSections, setOpenSections] = useState({});
  const isSidebarOpen = is_left_sidebar_open;
  const setIsSidebarOpen = (val) => dispatch(setLeftSidebarOpen(val));

  useEffect(() => {
    if (sidebar_menus.length > 0) {
      const initialOpen = { library: true, settings: true };
      sidebar_menus.forEach(menu => {
        initialOpen[menu.id] = true;
      });
      setOpenSections(initialOpen);
    }
  }, [sidebar_menus]);

  const toggleSection = (key) => {
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleStageChange = (stage) => {
    const { id, name } = stage;
    dispatch(setStageTab(id));
    const isLibrary = String(id).toLowerCase().includes('brand_library') ||
      String(name).toLowerCase().includes('brand library') ||
      String(id).toLowerCase().includes('my_library') ||
      String(name).toLowerCase().includes('my library');

    if (isLibrary) {
      navigate('/brand-library');
    } else {
      navigate('/');
    }
  };

  const getHeadingIcon = (iconName, label = "") => {
    const iconStr = String(iconName || "").toLowerCase();
    const labelStr = String(label || "").toLowerCase();

    if (labelStr.includes('job') || iconStr.includes('job')) return <JobsSvgIcon />;
    if (labelStr.includes('library') || iconStr.includes('library')) return <LibrarySvgIcon />;
    if (labelStr.includes('approval') || iconStr.includes('approval') || iconStr.includes('check')) return <ApprovalSvgIcon />;
    if (labelStr.includes('settings') || iconStr.includes('settings')) return <SettingsSvgIcon />;
    if (labelStr.includes('quote') || iconStr.includes('quote')) return <QuotesSvgIcon />;

    if (iconName && MuiIcons[iconName]) {
      const Icon = MuiIcons[iconName];
      return <Icon />;
    }

    return <MuiIcons.CheckCircleOutlineOutlined />;
  };

  const getDynamicHeadings = () => {
    // Find current process
    const currentProcess = company_process.find(p => p.id === selected_process_tab);

    // Check if proof feature is active
    const isProofActive = currentProcess && (currentProcess.standard_proof || currentProcess.annotated_proof);

    const dynamic = sidebar_menus
      .filter(menu => {
        if (menu.side_name.includes('Artwork Approval')) {
          return isProofActive;
        }
        return true;
      })
      .map(menu => ({
        key: menu.id,
        label: menu.side_name,
        icon: getHeadingIcon(menu.side_icon, menu.side_name),
        stages: menu.stages
      }));

    const hasLibrary = dynamic.some(item => item.key === 'library' || item.label === 'Library');

    if (!hasLibrary) {
      dynamic.push({
        key: 'library',
        label: 'Library',
        icon: getHeadingIcon('library', 'Library'),
        stages: [
          { id: 'my_library', name: 'My Library' },
          { id: 'brand_library', name: 'Brand Library' }
        ]
      });
    }

    return dynamic;
  };
  const getItemIcon = (stage) => {
    const { name, id, stage_logo } = stage;
    const sx = { fontSize: 16, color: '#c0c0c0', mr: 1.25 };

    if (stage_logo) {
      return (
        <Box
          component="img"
          src={stage_logo}
          alt={name}
          sx={{
            width: 16,
            height: 16,
            mr: 1.25,
            objectFit: 'contain',
            // enhance visibility if the logo is dark on dark or light on light, 
            // but usually icons are prepared well. 
            // We can add specific styles if needed.
          }}
        />
      );
    }

    const n = String(name || "").toLowerCase();
    if (id === 'brand_library') return <Box component="img" src={BrandLibraryIcon} sx={{ width: 16, height: 16, mr: 1.25, objectFit: 'contain' }} />;
    if (id === 'my_library') return <Box component="img" src={MyLibraryIcon} sx={{ width: 16, height: 16, mr: 1.25, objectFit: 'contain' }} />;
    if (n.includes('requested')) return <VerticalAlignTopIcon sx={sx} />;
    if (n.includes('progress')) return <AutorenewOutlinedIcon sx={sx} />;
    if (n.includes('complete')) return <CheckCircleOutlineIcon sx={sx} />;
    if (n.includes('hold')) return <PauseCircleOutlineOutlinedIcon sx={sx} />;
    if (n.includes('archive')) return <Inventory2OutlinedIcon sx={sx} />;
    if (n.includes('reject')) return <CancelOutlinedIcon sx={sx} />;

    return <RadioButtonUncheckedOutlinedIcon sx={sx} />;
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#FFF5F2' }}>
      {/* ===== SIDEBAR ===== */}
      <Box
        sx={{
          width: isSidebarOpen ? 210 : 64,
          flexShrink: 0,
          transition: 'width 0.2s',
          bgcolor: '#fff',
          borderRight: '1px solid #e8e8e8',
          py: 2,
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Toggle Button Container */}
        <Box sx={{ display: 'flex', justifyContent: isSidebarOpen ? 'flex-end' : 'center', px: 1, mb: 2 }}>
          <Tooltip title={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"} placement="right">
            <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)} size="small" sx={{ color: '#54565A' }}>
              {isSidebarOpen ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>
          </Tooltip>
        </Box>

        <List sx={{ px: isSidebarOpen ? 1 : 1, pl: isSidebarOpen ? 2 : 1 }}>
          {getDynamicHeadings().map(({ key, label, icon, stages }) => (
            <Box key={key}>
              {/* ===== HEADING ===== */}
              <ListItem disablePadding sx={{ mb: 0.5 }}>
                <Tooltip title={!isSidebarOpen ? label : ""} placement="right" arrow>
                  <ListItemButton
                    onClick={() => {
                      if (!isSidebarOpen) setIsSidebarOpen(true);
                      else toggleSection(key);
                    }}
                    sx={{
                      px: isSidebarOpen ? 0 : 0,
                      py: 0.5,
                      gap: 0.75,
                      justifyContent: isSidebarOpen ? 'flex-start' : 'center',
                      '&:hover': { bgcolor: 'transparent' }
                    }}
                  >
                    {isSidebarOpen && (
                      <ListItemText
                        primary={label}
                        primaryTypographyProps={{
                          fontSize: 15,
                          fontWeight: 600,
                          color: '#313131ff',
                          fontFamily: "'Inter Tight', sans-serif",
                          noWrap: true
                        }}
                        sx={{ flex: 'none' }}
                      />
                    )}
                    {React.cloneElement(icon, {
                      sx: {
                        fontSize: 20,
                        color: '#9e9e9e',
                        mr: isSidebarOpen ? 0 : 'auto',
                        ml: isSidebarOpen ? 0 : 'auto'
                      }
                    })}
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              {/* ===== ITEMS ===== */}
              <Collapse in={isSidebarOpen && openSections[key]} timeout="auto" unmountOnExit>
                <List disablePadding sx={{ mb: 1 }}>
                  {stages.map((stage, index) => {
                    const isActive = selected_stage_tab === stage.id;
                    const stageName = (String(stage.id).toLowerCase() === 'brand_library' ||
                      String(stage.id).toLowerCase() === 'my_library' ||
                      stage.name.toLowerCase().includes('brand library') ||
                      stage.name.toLowerCase().includes('my library'))
                      ? stage.name
                      : `${stage.name} - ${stage.job_count || 0}`;
                    return (
                      <ListItem key={`${key}-${stage.id}-${index}`} disablePadding sx={{ mb: 0 }}>
                        <Tooltip title={!isSidebarOpen ? stageName : ""} placement="right" arrow>
                          <ListItemButton
                            onClick={() => handleStageChange(stage)}
                            sx={{
                              px: 0,
                              py: 0.15,
                              justifyContent: isSidebarOpen ? 'flex-start' : 'center',
                              '&:hover': { bgcolor: 'transparent' }
                            }}
                          >
                            {getItemIcon(stage)}
                            {isSidebarOpen && (
                              <ListItemText
                                primary={stageName}
                                primaryTypographyProps={{
                                  fontSize: 13.5,
                                  color: isActive ? '#f4511e' : '#9e9e9e',
                                  fontWeight: isActive ? 500 : 400,
                                  fontFamily: "'Inter Tight', sans-serif",
                                  noWrap: true
                                }}
                              />
                            )}
                          </ListItemButton>
                        </Tooltip>
                      </ListItem>
                    );
                  })}
                </List>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>

      {/* ===== CONTENT AREA ===== */}
      <Box sx={{ flex: 1, p: 1.5 }}>
        <ChildComponent />
      </Box>
    </Box>
  );
};

export default StageList;
